import React, { useState, useEffect } from "react";
import PartnerLogin from "./PartnerLogin";
import PartnerRegister from "./PartnerRegister";
import PartnerDashboard from "./PartnerDashboard";

const PartnerPortal = () => {
  const [view, setView] = useState("login"); // login | register | dashboard
  const [partner, setPartner] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("partnerToken");
    const data = localStorage.getItem("partnerData");
    if (token && data) {
      setPartner(JSON.parse(data));
      setView("dashboard");
    }
  }, []);

  const handleLogin = (partnerData) => {
    setPartner(partnerData);
    setView("dashboard");
  };

  const handleRegister = (partnerData) => {
    setPartner(partnerData);
    setView("dashboard");
  };

  const handleLogout = () => {
    localStorage.removeItem("partnerToken");
    localStorage.removeItem("partnerData");
    setPartner(null);
    setView("login");
  };

  if (view === "dashboard" && partner) {
    return <PartnerDashboard partner={partner} onLogout={handleLogout} />;
  }

  if (view === "register") {
    return <PartnerRegister onRegister={handleRegister} onGoLogin={() => setView("login")} />;
  }

  return <PartnerLogin onLogin={handleLogin} onGoRegister={() => setView("register")} />;
};

export default PartnerPortal;
